import { theme } from 'ant-design-vue'

const token = {
  borderRadius: 2,
  colorPrimary: '#23ade5',
  colorBgLayout: '#ffffff',
}

const darkToken = {
  ...token,
  colorBgLayout: '#141414',
}

export const settings = {
  darkTheme: {
    algorithm: [theme.darkAlgorithm],
    token: darkToken,
  },
  darkCompactTheme: {
    algorithm: [theme.darkAlgorithm, theme.compactAlgorithm],
    token: darkToken,
  },
  lightTheme: {
    algorithm: [theme.defaultAlgorithm],
    token,
  },
  lightCompactTheme: {
    algorithm: [theme.defaultAlgorithm, theme.compactAlgorithm],
    token,
  },
}
